import { shuffle } from "./Utils";

export const images = {
    beyonce: require('../images/opponent/beyonce.jpg'),
    billy: require('../images/opponent/billy.jpg'),
    jay: require('../images/opponent/jay-z.jpg'),
    jeezy: require('../images/opponent/jeezy.jpg'),
    marilyn: require('../images/opponent/marilyn.jpg'),
    taylor: require('../images/opponent/taylor.jpg'),
    thomas: require('../images/opponent/thomas.jpg'),
    trump: require('../images/opponent/trump.jpg'),
};

export function getOpponents(qty: number) {
    let opponents: any[] = [];
    let names = shuffle(Object.keys(images));

    for (let i = 0; i < qty; i++) {
        const name = names[i];
        opponents.push({ name: name, image: images[name] });
    }

    return opponents;
}



// WEBPACK FOOTER //
// ./src/engine/Opponent.ts